<template>
  <div v-if="answerSheet && book" class="re-report text-center">
    <h1 class="dastnevis py-5">نتیجه عملکرد خود از داستان را بفهمیم</h1>
    <div ref="printMe">
      <div class="text-h6 text-center">
        ولی دانش آموز
        <v-chip outlined color="primary">
          {{
            this.$store.getters.user.firstname +
            " " +
            this.$store.getters.user.lastname
          }}
        </v-chip>
        نتیجه عملکرد شماره
        <v-chip outlined color="primary">
          {{ answerSheet.answerSheetCount }}
        </v-chip>
        فرزند شما در کتاب
        <v-chip outlined color="primary">
          {{ book.title }}
        </v-chip>
        در مهارت <strong>درک مطلب</strong> در قالب نمودار دایره ای و
        <strong>سطوح درک مطلب</strong>
        در نمودار میله ای نمایش داده شده است.
        <br />
        برای کسب اطلاعات و راهنمایی های بیشتر می توانید فایل کارنما و راهنما را
        دانلود نمایید
      </div>
      <div class="d-flex justify-center mt-5">
        <v-btn
          :loading="loading"
          depressed
          rounded
          color="primary"
          class="mx-2"
          @click="
            karnama(
              answerSheetCreateDate,
              fullName,
              answerSheet.answerSheetCount,
              book.title,
              book._id,
              answerSheetData.answerSheetItems
            )
          "
        >
          <v-icon class="ml-2">mdi-chart-timeline-variant-shimmer</v-icon>
          چاپ کارنمای عملکرد
        </v-btn>
        <v-btn
          depressed
          rounded
          color="info"
          class="mx-2"
          :href="`http://dl.pirls.ir/app/bookguide/${this.$route.params.id}.pdf`"
          target="_blank"
        >
          <v-icon class="ml-2">mdi-book-open-variant</v-icon>
          دانلود راهنمای کتاب
        </v-btn>
      </div>
      <v-row class="my-10">
        <v-col cols="12" md="7" class="d-flex align-center">
          <div class="flex-grow-1">
            <apex-chart
              ref="barChart"
              type="bar"
              :options="detailsOptions"
              :series="detailsSeries"
            />
          </div>
        </v-col>
        <v-col cols="12" md="5" class="d-flex align-center">
          <div class="flex-grow-1">
            <apex-chart
              ref="radialBarChart"
              type="radialBar"
              :options="totalScoreOptions"
              :series="totalScoreSeries"
            />
          </div>
        </v-col>
      </v-row>
    </div>

    <MenuComponent :book-id="this.$route.params.id" state="report" />
  </div>
</template>
<script>
import MenuComponent from "./Menu.vue";

export default {
  name: "report-component",
  components: { MenuComponent },
  data() {
    return {
      loading: false,
      answerSheet: null,
      answerSheetCreateDate: "",
      fullname: "",
      book: null,
      totalScoreOptions: {
        title: {
          text: "میانگین درک مطلب",
          align: "center",
          margin: 30,
          style: {
            fontSize: "20px"
          }
        },
        legend: {
          show: false
        },
        labels: ["درک مطلب"],
        colors: ["#3CD1A2"],
        chart: {
          fontFamily: "dana",
          fontSize: "20px"
        },
        plotOptions: {
          radialBar: {
            track: {
              background: "#E6E6E6"
            },
            dataLabels: {
              value: {
                fontSize: "20px",
                formatter: function (val) {
                  return Math.round(val) + "%";
                }
              }
            }
          }
        },
        tooltip: {
          enabled: false
        }
      },
      totalScoreSeries: [],
      detailsOptions: {
        title: {
          text: "سطوح درک مطلب",
          align: "center",
          margin: 30,
          style: {
            fontSize: "20px"
          }
        },
        yaxis: {
          reversed: true,
          labels: {
            align: "left",
            style: {
              fontSize: "16px"
            }
          }
        },
        xaxis: {
          max: 100,
          labels: {
            style: {
              fontSize: "16px"
            }
          }
        },
        legend: {
          show: false
        },
        chart: {
          fontFamily: "dana",
          toolbar: {
            show: false
          }
        },
        tooltip: {
          enabled: false
        },
        plotOptions: {
          bar: {
            distributed: true,
            horizontal: true
          }
        },
        colors: ["#3CD1A2", "#FF5670", "#F4A046", "#3C8FD1"],
        labels: ["ارزیابی", "تفسیر", "استنباط", "تمرکز"]
      },
      detailsSeries: [],
      answerSheetData: []
    };
  },
  created() {
    this.fullName =
      this.$store.getters.user.firstname +
      " " +
      this.$store.getters.user.lastname;
    this.$api.get("/answerSheet/" + this.$route.params.id).then((res) => {
      const answerSheet = res.data.answerSheet;
      this.answerSheet = res.data;
      this.answerSheetCreateDate = this.$moment(
        answerSheet.createDate,
        "YYYY/MM/DD"
      )
        .locale("fa")
        .format("YYYY/MM/DD");
      this.calculateTotalScore(answerSheet.totalScore);
      this.detailsSeries.push({
        data: [
          Math.round((answerSheet.focusScore * 100) / 3),
          Math.round((answerSheet.inferenceScore * 100) / 3),
          Math.round((answerSheet.interpretationScore * 100) / 3),
          Math.round((answerSheet.assessmentScore * 100) / 3)
        ]
      });
      this.$api.get("/answerSheetItem/" + answerSheet._id).then((res) => {
        this.answerSheetData = res.data;
      });
    });
    this.$api.get("/book/" + this.$route.params.id).then((res) => {
      this.book = res.data.book;
    });
  },
  methods: {
    calculateTotalScore(totalScore) {
      const totalScoreTruePercentage = (totalScore * 100) / 12;
      this.totalScoreSeries.push(totalScoreTruePercentage);
    },
    async karnama(
      date,
      fullName,
      examCount,
      bookTitle,
      bookId,
      answerSheetData
    ) {
      this.loading = true;

      const doc = this.$jspdf({
        orientation: "portrait",
        format: "a4"
      });

      doc.setFont("iransansdn");

      var bg =
        "https://pirls.ir" + require("@/assets/images/report/bg.jpg");

      doc.addImage(bg, 0, 0, 210, 297);

      var bookImg =
        "https://pirls.ir" +
        require(`@/assets/images/books/${bookId}.jpg`);

      doc.addImage(bookImg, 14, 25.5, 30, 43);

      doc.setTextColor("#444444");
      doc.setFontSize("8");
      doc.text("تاریخ: " + date, 10, 10);

      doc.setTextColor("#444444");
      doc.setFontSize("9");
      doc.text("ولی دانش آموز ", 195, 33, {
        align: "right"
      });

      doc.setTextColor("#222222");
      doc.setFontSize("10");
      doc.text(fullName, 174, 33, {
        align: "right"
      });

      var fullMessage =
        " بدین وسیله نتیجه عملکرد شماره " +
        examCount +
        " فرزند شما در کتاب " +
        bookTitle;

      doc.setTextColor("#444444");
      doc.setFontSize("9");
      doc.text(fullMessage, 195, 41, {
        align: "right"
      });

      doc.setTextColor("#444444");
      doc.setFontSize("9");
      doc.text(
        ".در مهارت درک مطلب در قالب نمودار دایره ای و سطوح درک مطلب در نمودار میله ای نمایش داده شده است",
        195,
        49,
        {
          align: "right"
        }
      );

      doc.setTextColor("#444444");
      doc.setFontSize("9");
      doc.text(
        ".همچنین در جدول بازخورد ؛ عملکرد دانش آموز در پاسخ به سوالات قابل مشاهده است",
        195,
        57,
        {
          align: "right"
        }
      );

      const guidtxt =
        ".برای راهنمایی های بیشتر و بهبود سواد خواندن می توانید فایل راهنما مربوط به این کتاب را دانلود و مطالعه کنید";
      doc.setTextColor("#808080");
      doc.setFontSize("8");
      doc.text(guidtxt, 195, 66, {
        align: "right"
      });

      const barChart = await this.$refs.barChart.chart
        .dataURI()
        .then((imgURI) => {
          return imgURI;
        });

      const radialBarChart = await this.$refs.radialBarChart.chart
        .dataURI()
        .then((imgURI) => {
          return imgURI;
        });

      doc.addImage(radialBarChart.imgURI, 10, 80, 70, 61);
      doc.addImage(barChart.imgURI, 92, 80, 105, 61);

      var answerSheetDataArray = [];

      let index = 1;

      answerSheetData.forEach((res) => {
        const question = res.question.text;
        const score = res.answer.score;
        let answerState = "نادرست";
        if (score === 1) {
          answerState = "درست";
        }
        answerSheetDataArray.push({ index, question, answerState });
        index++;
      });

      doc.autoTable({
        theme: "grid",
        columnStyles: {
          answerState: { halign: "center", font: "iransansdn", fontSize: 8 },
          question: { halign: "right", font: "iransansdn", fontSize: 7 },
          index: { halign: "center", font: "iransansdn", fontSize: 8 }
        },
        headStyles: {
          halign: "center",
          font: "iransansdn"
        },
        margin: { left: 12.5, top: 156.5 },
        body: answerSheetDataArray,
        columns: [
          {
            header: "پاسخ شما",
            dataKey: "answerState"
          },
          {
            header: "سوال",
            dataKey: "question"
          },
          {
            header: "شماره",
            dataKey: "index"
          }
        ]
      });

      doc.save("karnama.pdf");

      this.loading = false;
    }
  }
};
</script>
<style>
.v-card__subtitle,
.v-card__text {
  letter-spacing: 0;
}
.apexcharts-yaxis-texts-g {
  transform: translate(96%, 0);
}
.apexcharts-legend-text {
  padding: 0 5px;
}
</style>
